import React, {RefObject, useRef} from "react"
import {findDOMNode} from "react-dom"

import ItemModelV2 from "../../../../../../../model2/item2/item-model"
import PopoverPosition from "../../../../../../../gd-components/gd-popover/popover-position"
import ProjectStatusSelectorPopover from "../../../../../../../gd-ui/select-status/project/popover"

type Props = {
    className?      : string
    style?          : any

    listItem        : ItemModelV2
    status          : any

    showPopover     : boolean

    onMouseEnter    : callback
    onMouseLeave    : callback
    onClick         : func
    onValueChange   : callback
    onHidePopover   : func
}

// const debug = "FieldProjectStatus_TableCellCalculated_Hovered"
const debug = false

export default function FieldProjectStatus_TableCellCalculated_Hovered(props: Props) {

    const refSelf: RefObject<any> = useRef()

    return (
        <div ref            = {refSelf}
             className      = "cell-flex is-hovered"
             style          = {props.style}
             onMouseEnter   = {props.onMouseEnter}
             onMouseLeave   = {props.onMouseLeave}>
            <div className="ui5-field-editable size-small is-hovered w-100-percent h-100-percent"
                 onClick={props.onClick}>

                <div className={Classes('ui5-status-list status-c{0}'.f(props.status.color), props.className)}>
                    <div className="max-w-100-percent txt-truncate">{props.status.name}</div>
                </div>

                <div className="buttons flex-no-shrink">
                    <div className="btn-arrow"/>
                </div>
            </div>

            {props.showPopover &&
                <ProjectStatusSelectorPopover
                    hidePopover         = {props.onHidePopover}
                    project             = {props.listItem.project}
                    onStatusSelect      = {props.onValueChange}
                    togglePopover       = {props.onHidePopover}
                    hint                = {true}
                    popoverPosition     = {PopoverPosition.top()}
                    getTarget           = {() => findDOMNode(refSelf.current)}
                />}
        </div>
    )
}
